
import ContentService from '../../services/contents'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createContent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      ContentService.createContent(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating campaign'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getContents ({ commit },params) {

    return new Promise((resolve, reject) => { 
      ContentService.getContents(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getContentTags ({ commit }, params) {
    return new Promise((resolve, reject) => {
      ContentService.getContentTags(params).then((response) => {
        resolve(response.data)
      }).catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getContent ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      ContentService.getContent(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getTarget ({ commit }, { contentId, targetId }) {

    return new Promise((resolve, reject) => { 
      ContentService.getTarget(contentId, targetId).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getVariant ({ commit }, { contentId, targetId, variantId }) {

    return new Promise((resolve, reject) => { 
      ContentService.getVariant(contentId, targetId, variantId).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteContent ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      ContentService.deleteContent(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateContent ({ commit }, content) {

    return new Promise((resolve, reject) => { 
      ContentService.updateContent(content).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateExperience ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.updateExperience(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateTargetABTest ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ContentService.updateTargetABTest(payload).then(response=> {
        resolve(response.data)
      })
      .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateVariant ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.updateVariant(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  createVariant ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.createVariant(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteVariant ({ commit }, { contentId, targetId, variantId }) {

    return new Promise((resolve, reject) => { 
      ContentService.deleteVariant(contentId, targetId, variantId).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  createExperience({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.createExperience(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getVariantHistory ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.getVariantHistory(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  generateContentFromImage ({ commit }, payload) {

    return new Promise((resolve, reject) => { 
      ContentService.generateContentFromImage(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
  
  // eslint-disable-next-line no-unused-vars
  getContentVariant({ commit }, payload) {
    return new Promise((resolve, reject) => { 
      ContentService.getVariant(payload.personalizationId, payload.targetId, payload.variantId).then(response => {
        if (response?.data?.data) {
          resolve(response.data.data)
        } else {
          reject({ message: 'Error getting variant' })
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCustomEventMetrics({ commit }, experienceId) {
    return new Promise((resolve, reject) => { 
      ContentService.getCustomEventMetrics(experienceId).then(response=> {
        resolve(response.data)
      })
      .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getContentsWithFeedback({ commit }, project) {
    return new Promise((resolve, reject) => { 
      ContentService.getContentsWithFeedback(project).then(response=> {
        resolve(response.data)
      })
      .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateHistory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ContentService.updateHistory(payload).then(response=> {
        resolve(response.data)
      })
      .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  exportFeedback({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ContentService.exportFeedback(payload).then(response=> {
        resolve(response.data)
      })
      .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getAskCalvinTemplate({ commit }, payload) {
    return new Promise((resolve) => { 
      resolve({
        "scratch": true,
        "goals": [],
        "name": "Ask Calvin",
        "lang": "es",
        "description": "Pide a Calvin que te ayude a crear tu contenido",
        "img": "https://public-assets.gopersonal.ai/uploads/2026/05/06840e1d-bb16-4846-a8c5-b4901c23bc47.png",
        "type": "personalization",
        "calvin": true,
        "value": {
            "groups": [],
            "variables": [],
            "html": "",
            "css": "",
            "js": ""
        }
    })
    });
  }
}